module.exports = __webpack_public_path__ + "static/img/08018C_1_2_C_20220509_fit.7ce0797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08018C_1_2_C_20220509_fit.png
// module id = A9OX
// module chunks = 0